import React, { Dispatch, SetStateAction, useState } from "react";
import { Dialog, DialogContent, Box, Typography, Stack } from "@mui/material";
import demoImage from "../../../../assets/image/png/demo.png";
import productionImage from "../../../../assets/image/png/production.png";
import "./productionMovementConfirmationPopup.css";
import { updateOnboardingStatus, updateProductionMovement } from "../../../../services/userOnboardService/userOnboardService";
import { useNavigate } from "react-router-dom";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const Popup = (props: {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
    const navigate = useNavigate();
    const [dragging, setDragging] = useState(false);
    const [dropped, setDropped] = useState(false);

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    if (!dropped) {
            setDragging(true);
        }
    };

    const handleDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
        setDragging(false);
    };

    const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        setDropped(true);
        setDragging(false);
        props.setOpen(false);
        await updateProductionMovement(true, async () => {
            await updateOnboardingStatus(false);
            navigate("/dashboard", {
                state: {
                    showProductionMovementSuccessPopup: true
                }
            });
        });
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleClose = () => {
        setDropped(false);
        props.setOpen(false);
    };

    return (
        <Dialog open={props.open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogContent sx={{ textAlign: "center", padding: 3 }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "20px",
                        borderRadius: "8px",
                        backgroundColor: "#f7f8fa",
                        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            onDragStart={handleDragStart}
                            onDragEnd={handleDragEnd}
                            draggable
                            sx={{
                                width: "120px",
                                borderRadius: "8px",
                                padding: "5px",
                                cursor: "grab",
                            }}
                        >
                            <img
                                src={demoImage}
                                alt="Demo"
                                draggable={false}
                                style={{ width: "100%", borderRadius: "8px" }}
                            />
                        </Box>
                        <Typography variant="body1">Demo</Typography>
                    </Box>

                    <Box sx={{ textAlign: "center" }}>
                        <Box
                            sx={{
                                position: "relative",
                                width: "80px", // Width of the arrow
                                height: "30px", // Height of the arrow
                                background: "#17C3B2", // Base background color
                                overflow: "hidden", // Ensures shimmer doesn't go outside the bounds
                                clipPath: "polygon(0 30%, 60% 30%, 60% 0, 100% 50%, 60% 100%, 60% 70%, 0 70%);",
                                margin: "0 20px", // Space between arrow and boxes
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    top: 0,
                                    left: "-100%", // Start shimmer off-screen
                                    width: "200%", // Make it large enough to cover the arrow
                                    height: "100%",
                                    background:
                                        "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5), transparent)",
                                    animation: "shimmer 2s infinite", // Shimmer effect
                                },
                            }}
                        />
                        <Typography variant="body2" sx={{ marginTop: 1 }}>
                            Drag to production
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            sx={{
                                width: "120px",
                                borderRadius: "8px",
                                padding: "5px",
                                border: dragging ? "1px solid #237C9D" : "none",
                                backgroundColor: dragging ? "#E0F7FA" : null,
                            }}
                        >
                            <img
                                src={productionImage}
                                alt="Production"
                                draggable={false}
                                style={{ width: "100%", borderRadius: "8px" }}
                            />
                        </Box>
                        <Typography variant="body1">
                            Production
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        textAlign: "center",
                        backgroundColor: "#fff3e0",
                        borderRadius: "8px",
                        padding: "10px",
                        marginTop: "20px",
                    }}
                >
                    <Stack
                        direction="row"
                    >
                        <InfoOutlinedIcon sx={{height: 14, width: 14, marginTop: "3px", marginRight: "3px", color: "#CC911F"}} />
                        <Typography variant="body2" sx={{ color: "#CC911F" }}>
                            After moving to production, you will be redirected to
                            the SalesCode portal
                        </Typography>
                    </Stack>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default Popup;
